<template>
  <li :class="{ 'gift--booked': booked }"
      class="gift">
    <router-link :to="{ name: 'GiftDetail', params: { id } }">
      <div :style="{ backgroundImage: `url(${loadImages ? image280x232 : ''})` }" class="gift__image"/>
      <h2 :style="{ backgroundImage: `url(${caranec})` }">{{ name }}</h2>
    </router-link>

    <p v-if="booked" class="gift__booked">Zamluveno</p>
  </li>
</template>

<script>
import caranec from '@/assets/caranec.png';

export default {
  name: 'Gift',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    image280x232: {
      type: String,
      required: true,
    },
    booked: {
      type: Boolean,
      required: true,
    },
    bookersEmail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caranec,
      loadImages: false,
    };
  },
  mounted() {
    this.$nextTick(function loadImages() {
      this.loadImages = true;
    });
  },
};
</script>

<style lang="scss" scoped>
  .gift {
    min-width: 300px;
    min-height: 300px;
    margin: 20px;
    background-color: #fff;
    border-radius: 6px;
    position: relative;

    & a {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }

    & h2 {
      width: 100%;
      padding: 18px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      color: white;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      font-size: 1.1rem;
    }

    &__image {
      width: calc(100% - 20px);
      height: 100%;
      margin-top: 10px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    &__booked {
      color: black;
      position: absolute;
      text-align: center;
      width: 100%;
      top: 38%;
      font-size: 2rem;
      background: white;
    }

    &--booked {
      filter: grayscale(1);
    }
  }
</style>
